import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Contacto, TipoContacto, Entidad } from '../../../interfaces/contacto';
// import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { TipoEntidad } from '../../../interfaces/entidad';
import { ContactoService } from '../../../providers/contacto.service';
import { Examen } from '../../../interfaces/examen';
import { KitBienvenida } from '../../../interfaces/kit-bienvenida';
import { PerfilWeb } from '../../../interfaces/perfil-web';
import { TipoPago } from '../../../interfaces/tipo-pago';
import { EntidadService } from '../../../providers/entidad.service';
import { TipoPagoService } from '../../../providers/tipo-pago.service';
import { PersonasService } from '../../../providers/personas.service';
// import { ContactoService } from '../../../../providers/contacto.service';
// import { Telefono, telefonoValidator } from '../../../../components/telefono/telefono.component';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss']
})
export class ContactoComponent implements OnInit {
  @Input() contactoData: Contacto = null;
  public entidadesFiltroCtrl: FormControl = new FormControl();
  public entidadesFiltradas: ReplaySubject<Entidad[]> = new ReplaySubject<Entidad[]>(1);
  // entidad_id: any = -1;
  contacto: Contacto;
  private debounceTimer: any;
  tiene_entidad_asociada: boolean = false;
  tiposContacto: TipoContacto[] = [];
  tiposContactoSinFiltro: any[] = [];
  cargandoTiposContacto: boolean = false;
  cargando: boolean = false;
  entidades: any[] = [];
  @Output() onContactoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  @Output() onEntidadInput = new EventEmitter(); // datos del formulario cambian
  nombreFormControl = new FormControl('', [
    Validators.required
  ]);
  cargandoEntidades = false;
  apellidoFormControl = new FormControl();
  razonSocialFormControl = new FormControl();
  cargoFormControl = new FormControl();
  emailFormControl = new FormControl('', [Validators.email]);
  celularCodigoPaisFormControl = new FormControl();
  celularCodigoAreaFormControl = new FormControl();
  celularNumeroFormControl = new FormControl();
  telefonoCodigoPaisFormControl = new FormControl();
  telefonoCodigoAreaFormControl = new FormControl();
  telefonoNumeroFormControl = new FormControl();
  internoFormControl = new FormControl();
  fechaAltaFormControl = new FormControl();
  dia_nacimientoFormControl = new FormControl();
  mes_nacimientoFormControl = new FormControl();
  fechaModificacionFormControl = new FormControl();
  usuarioModificacionFormControl = new FormControl();
  fechaCertificacionFormControl = new FormControl();
  fechaUltimaCertificacionFormControl = new FormControl();
  examenesFormControl = new FormControl();
  kitsFormControl = new FormControl();
  perfilesFormControl = new FormControl();
  pagosFormControl = new FormControl();
  tipoContactoFormControl = new FormControl('', [
    Validators.required
  ]);
  entidadFormControl = new FormControl('', [
    Validators.required
  ]);
  examenes: Examen[] = [];
  kits: KitBienvenida[] = [];
  perfiles: PerfilWeb[] = [];
  pagos: TipoPago[] = [];
  numberOfDays: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: string[] = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  constructor(
    private contactoService: ContactoService,
    private entidadService: EntidadService,
    private pagoService: TipoPagoService,
    private _personasSv: PersonasService,
  ) { }

  ngOnInit(): void {
    console.log('this.contactoData', this.contactoData);
    if (this.contactoData) {
      // this.contacto = new Contacto(
      //   this.contactoData.apellido,
      //   this.contactoData.cargo,
      //   this.contactoData.celular,
      //   this.contactoData.email,
      //   this.contactoData.entidad,
      //   this.contactoData.examen,
      //   this.contactoData.nombre,
      //   this.contactoData.razonSocial,
      //   this.contactoData.telefono,
      //   this.contactoData.tipoContacto,
      //   this.contactoData.IdContacto,
      //   this.contactoData.interno,
      //   this.contactoData.id_entidad,
      //   this.contactoData.fechaNacimiento,
      //   this.contactoData.fechaModificacion,
      //   this.contactoData.fechaCertificacion,
      //   this.contactoData.fechaUltimaCertificacion,
      //   this.contactoData.pago,
      //   this.contactoData.kit,
      //   this.contactoData.perfil
      // )
      this.contacto = new Contacto();
      this.contacto = this.contactoData;

      // console.log('Contacto', this.contacto);
      // this.telefonoFormControl.setValue(this.contacto.telefono);
      // this.celularFormControl.setValue(this.contacto.celular);
    } else {
      this.contacto = new Contacto();
      // console.log('Contacto', this.contacto);

    }
    let contacto_asociado = null;
    if (this.contacto.entidad && this.contacto.entidad.IdEntidad)
      contacto_asociado = this.contacto.entidad.razonSocial;
    this.traerEntidades(contacto_asociado);
    // cuando cambia el valor del buscador, filtramos
    this.entidadesFiltroCtrl.valueChanges.subscribe(() => {
      this.filtrarEntidades();
    });
    this.tiposContacto = [];
    this.entidades = [];
    this.cargandoTiposContacto = true;
    this.contactoService.getTiposContacto().subscribe(
      respuesta => {
        // console.log('Respuesta TipoContactos', respuesta.data.tiposContacto);

        if (respuesta.estado == 1 && respuesta.data) {
          if (respuesta.data.tiposContacto) {
            this.tiposContactoSinFiltro = respuesta.data.tiposContacto;
            this.tiposContacto = respuesta.data.tiposContacto.filter(tipoContacto => tipoContacto.TipoContactoEstado == 1);

            // respuesta.data.tiposContacto.forEach(tipoContacto => {
            //   this.tiposContacto.push(<TipoContacto>{
            //     IdTipoContacto: tipoContacto.IdTipoContacto,
            //     tipoContactoDesc: tipoContacto.TipoContactoDesc
            //   });
            // });
          }
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'El contacto no podrá ser asignado'
          });
        }
        this.seleccionarContacto();
        this.cargandoTiposContacto = false;
      },
      error => {
        this.cargandoTiposContacto = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );


    this.entidadService.getExamen().subscribe(
      respuesta => {
        // console.log('Examen', respuesta);
        this.examenes = respuesta.data.examenes;
      },
    );
    this.entidadService.getKitBienvenida().subscribe(
      respuesta => {
        // console.log('Kit Bienvenida', respuesta);
        this.kits = respuesta.data.kits;
      },
    )
    this.entidadService.getPerfilWeb().subscribe(
      respuesta => {
        // console.log('Perfil Web', respuesta);
        this.perfiles = respuesta.data.perfiles;
      },
    )
    this.traerPagos();
  }
  seleccionarContacto() {
    let mayus = this.contacto.tipoContacto.tipoContactoDesc;
    // console.log('Aca esta el contacto!!!!!!!', this.tiposContactoSinFiltro);

    this.tiposContactoSinFiltro.forEach( cont =>{
      if(mayus != null){
        // console.log('Aca entre', mayus);
        // console.log('Aca tambien', cont.TipoContactoDesc)
        if(mayus == cont.TipoContactoDesc){
          // console.log('Aca llegue');
          if(cont.TipoContactoEstado == 0){
            // console.log('')
            this.tiposContacto.push(cont);
          }
        }
      }else{
        return
      }
    })
  }


  /**
   * Traemos las entidades para mostrarlas en la carga
   */
  traerEntidades(filtro): void {
    this.cargandoEntidades = true;
    this.entidades = [];
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 200
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        razonSocial: filtro
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          this.cargandoEntidades = false;
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              email: prospecto.email,
              paisEntidad: prospecto.paisEntidad,
              localidadEntidad: prospecto.localidadEntidad,
              provinciaEntidad: prospecto.provinciaEntidad,
              clasificacionEntidad: prospecto.clasificacionEntidad,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion,
              },
              observacion: prospecto.observacion,


            });
          });
          // actualizar opciones del filtro
          //this.filtrarEntidades();
        }
      },
      error => {

      }
    );
  }
  private filtrarEntidades() {
    if (this.entidadesFiltroCtrl.value.length <= 2) {
      return;

    }

     if (this.debounceTimer) {
       clearTimeout(this.debounceTimer);
    }
     this.debounceTimer = setTimeout(() => {
      const search = this.entidadesFiltroCtrl.value;
      // console.log(search);
      this.traerEntidades(search);
      this.entidadesFiltradas.next(this.entidades.slice());
      this.debounceTimer = null;
    }, 600);
    //vER POR QUE LIMPIA EL CAMPO ENTIDAD Y SI CON ESO SE SOLUCIONA EL PROBLEMA DE FONDO

  }



  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onContactoInput.emit();
    // console.log('Contacto', this.tipoContactoFormControl.value);
  }

  onInput2(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onEntidadInput.emit();
    // console.log('Entidad', this.entidadFormControl.value);
  }

  compararTipoContacto(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdTipoContacto == tipo2.IdTipoContacto;
    }

    return false;
  }

  compararEntidad(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdEntidad == tipo2.IdEntidad;
    }

    return false;
  }

  traerPagos(): void {
    this.pagos = [];
    this.pagoService.getTiposPago(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.pagos) {
          respuesta.data.pagos.forEach((pago) => {
            this.pagos.push(<TipoPago>{
              id: pago.id,
              descripcion: pago.descripcion
            });
          });
          // console.log('Tipos de Pago', this.pagos);

        }
      },
      () => {
      }
    );
  }

  onInputLeyenda(event) {

    // this.form.get('contacto').setValue(null);
    //    this.tieneContactoAsig = true;


  }

  getContacto(): Contacto {
    if (this.nombreFormControl.hasError('required') ||
      this.tipoContactoFormControl.hasError('required') ||
      this.entidadFormControl.hasError('required')||
      this.emailFormControl.hasError('required') ||
      this.emailFormControl.hasError('email') ||
      (this.telefonoNumeroFormControl.hasError('required') && this.telefonoCodigoAreaFormControl.hasError('required') && this.telefonoCodigoPaisFormControl.hasError('required') && this.celularNumeroFormControl.hasError('required') && this.celularCodigoAreaFormControl.hasError('required') && this.celularCodigoPaisFormControl.hasError('required'))
    ) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.nombreFormControl.markAsTouched();
      this.tipoContactoFormControl.markAsTouched();
      this.emailFormControl.markAsTouched();
      this.telefonoNumeroFormControl.markAsTouched();
      this.telefonoCodigoAreaFormControl.markAsTouched();
      this.telefonoCodigoPaisFormControl.markAsTouched();
      this.celularNumeroFormControl.markAsTouched();
      this.celularCodigoAreaFormControl.markAsTouched();
      this.celularCodigoPaisFormControl.markAsTouched();
      this.entidadFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    if (this.tipoContactoFormControl.hasError('required') || this.entidadFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.tipoContactoFormControl.markAsTouched();
      this.entidadFormControl.markAsTouched();

      throw "Datos incorrectos";
    }
    return this.contacto;
  }

  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }



}
